import axios, { AxiosError } from 'axios';
import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { ReferenceLocation } from '@/types';
import { GET_REFERENCE_LOCATIONS_API_ENDPOINT } from '@/constants';

export const useGetReferenceLocations = (
  query: string,
  options?: Partial<UseQueryOptions<ReferenceLocation[], AxiosError>>,
) => {
  return useQuery<ReferenceLocation[], AxiosError>({
    queryKey: ['reference-locations', query],
    queryFn: () =>
      axios
        .get<
          ReferenceLocation[]
        >(GET_REFERENCE_LOCATIONS_API_ENDPOINT, { params: { query, limit: 50 } })
        .then((res) => res.data),
    enabled: query.length >= 2,
    staleTime: 60_000,
    ...options,
  });
};
